import { useEffect, useState, useRef } from "react";
import {
  faArrowCircleLeft,
  faCircleXmark,
  faSearch,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HeadlessTippy from "@tippyjs/react/headless";
import classNames from "classnames/bind";
import { Wrapper as PopperWrapper } from "../../../components/Popper";
import styles from "./SearchMobile.module.scss";
import AccountItem from "../../../components/AccountItem";
import { useDebounce } from "../../../hooks";
import { callFetchPost } from "../../../config/api";
import { ReactComponent as SearchIcon } from "../../../assets/icons/icon-search.svg";

const cx = classNames.bind(styles);

function Search() {
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState<any>([]);
  const [showResult, setShowResult] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  //   const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const debouncedValue = useDebounce(searchValue, 500);

  const inputRef: any = useRef();

  useEffect(() => {
    if (!debouncedValue.trim()) {
      setSearchResult([]);
      return;
    }

    const fetchApi = async () => {
      setLoading(true);

      const result: any = await callFetchPost(
        `&populate=categoryId&fields=categoryId._id,categoryId.name&current=1&pageSize=6&sort=-updatedAt&title=${debouncedValue}`
      );

      setSearchResult(result?.data?.result);
      setLoading(false);
    };

    fetchApi();
  }, [debouncedValue]);

  const handleClear = () => {
    setSearchValue("");
    setSearchResult([]);
    inputRef.current.focus();
  };

  const handleHideResult = () => {
    setShowResult(false);
  };

  const handleChange = (e: any) => {
    const searchValue = e.target.value;
    if (!searchValue.startsWith(" ")) {
      setSearchValue(searchValue);
    }
  };

  return (
    <>
      <input
        type="checkbox"
        className={cx("search__input")}
        name=""
        id="search-mobile-input"
        checked={isMenuOpen}
        onChange={toggleMenu} // Khi bạn bấm input checkbox, trạng thái của menu sẽ thay đổi
      />
      <label className={cx("icon-search-left")} htmlFor="search-mobile-input">
        <SearchIcon width={24} height={24} />
      </label>
      <div className={cx("wrapper")}>
        <label className={cx("icon-arrow-left")} htmlFor="search-mobile-input">
          <FontAwesomeIcon icon={faArrowCircleLeft} />
        </label>
        <HeadlessTippy
          placement="bottom"
          interactive
          visible={showResult && searchResult.length > 0}
          render={(attrs: any) => (
            <div className={cx("search-result")} tabIndex="-1" {...attrs}>
              <PopperWrapper>
                <h4 className={cx("search-title")}>Bài viết</h4>
                {searchResult &&
                  searchResult.length > 0 &&
                  searchResult.map((result: any) => (
                    <AccountItem key={result.id} data={result} />
                  ))}
              </PopperWrapper>
            </div>
          )}
          onClickOutside={handleHideResult}>
          <div className={cx("search")}>
            <input
              ref={inputRef}
              value={searchValue}
              placeholder="Tìm kiếm bài viết tại đây..."
              spellCheck={false}
              onChange={handleChange}
              onFocus={() => setShowResult(true)}
            />
            {!!searchValue && !loading && (
              <button className={cx("clear")} onClick={handleClear}>
                <FontAwesomeIcon icon={faCircleXmark} />
              </button>
            )}
            {loading && (
              <FontAwesomeIcon className={cx("loading")} icon={faSpinner} />
            )}

            <button
              className={cx("search-btn")}
              onMouseDown={(e) => e.preventDefault()}>
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>
        </HeadlessTippy>
      </div>
    </>
  );
}

export default Search;
